import { makeAutoObservable } from "mobx";

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  APPOINTMENT_TYPE,
  SEARCH_TYPE_APPOINTMENT,
} from "app/common/LocalConst";
import {
  getBySriId,
  saveOrUpdateAppointmentByStaff,
} from "app/services/AppointmentService";
import moment from "moment";
import { getCurrentStaff } from "app/common/LocalFunction";

const DEFAULT_APPOINTMENT = {
  orderTime: new Date(),
  calendarSelect: new Date(),
  startTime: new Date(),
  searchType: SEARCH_TYPE_APPOINTMENT[0].value,
  appointmentType: APPOINTMENT_TYPE[1].value,
};
export default class PatientRankStore {
  initialTreatmentAppointment = { ...DEFAULT_APPOINTMENT };
  editable = true;
  constructor() {
    makeAutoObservable(this);
  }

  saveOrUpdateAppointmentByStaff = (obj, { setSubmitting }) => {
    let { patient, ...ortherData } = obj;
    // if (patient?.patientAvatarId?.[0]) {
    //   patient.patientAvatarId =
    //     patient?.patientAvatarId?.[0]?.fileDescription?.id;
    // }
    saveOrUpdateAppointmentByStaff({
      patient,
      ...ortherData,
    })
      .then(({ data }) => {
        toast.success("Đặt lịch thành công!");
        this.getAppointmentBySriId(obj?.serviceRequestItemId);
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  getAppointmentBySriId = async (id, defaultDepartment, service) => {
    try {
      const { data } = await getBySriId(id);
      if (data?.id) {
        this.setEditable(false);
      }
      if (data) {
        this.initialTreatmentAppointment = data;
      } else {
        let totalEstimatedTime = defaultDepartment?.avgConsultationTime
          ? defaultDepartment?.avgConsultationTime?.toString()
          : null;

        this.initialTreatmentAppointment = {
          ...this.initialTreatmentAppointment,
          department: defaultDepartment,
          note: `Điều trị buổi kế tiếp cho dịch vụ ${service?.name}`,
          totalEstimatedTime,
          endTime: moment(new Date()).add(totalEstimatedTime, "minutes"),
        };
      }
    } catch (error) {
      toast.error(error);
    }
  };

  handleSetInitialAppointment = (obj) => {
    if (obj?.id) {
      this.setEditable(false);
    }
    this.initialTreatmentAppointment = obj;
  };

  setEditable = (state) => {
    this.editable = state;
  };
  resetStore = () => {
    this.initialTreatmentAppointment = {
      ...DEFAULT_APPOINTMENT,
    };
    this.editable = true;
  };
}
